import React from "react";

const DeleteAccountPopup = ({ isOpen, onClose, onDelete, isDeleting }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
      <div className="popup-for-delete-account">
        <h2 className="popup-for-delete-account-heading">
          Are you sure you want to delete your account permanently?
        </h2>
        <p className="popup-for-delete-account-subheading">
          By doing this your account will be deleted permanently and you will
          not be able to recover your account anymore.
        </p>
        <div className="flex justify-between gap-4 mt-4">
          <button
            onClick={onClose}
            disabled={isDeleting}
            className="flex-1 py-2 popup-for-delete-account-cancel hover:bg-gray-100 transition"
          >
            Cancel
          </button>
          <button
            onClick={onDelete}
            disabled={isDeleting}
            className={`flex-1 py-2 rounded-lg ${
              isDeleting
                ? "bg-gray-400 text-white cursor-not-allowed"
                : "bg-red-600 text-white hover:bg-red-700 transition"
            }`}
          >
            {isDeleting ? "Deleting..." : "Delete Account"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteAccountPopup;
